import React from 'react';
import ReactDOM from 'react-dom';
import * as serviceWorkerRegistration from './serviceWorkerRegistration';
import reportWebVitals from './reportWebVitals';
import { AuthProvider } from './context/AuthContext';
import Loading from './components/Loading/Loading';
import 'antd/dist/antd.css'
import { PlayerProvider } from './context/PlayerContext';
import { ThemeProvider } from './context/ThemeContext';
import { AppProvider } from "./context/AppContext";
import { UserProvider } from './context/UserContext';

const HOC = React.lazy(() => import("./App"));

ReactDOM.render(
  <React.StrictMode>
    <AppProvider>
      <ThemeProvider>
        <AuthProvider>
          <UserProvider>
            <PlayerProvider>
              <React.Suspense fallback={<Loading />}>
                <HOC />
              </React.Suspense>
            </PlayerProvider>
          </UserProvider>
        </AuthProvider>
      </ThemeProvider>
    </AppProvider>
  </React.StrictMode>,
  document.getElementById('root')
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://cra.link/PWA
serviceWorkerRegistration.register();

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
